
import {Component, Vue} from "vue-property-decorator";
import {SessionGetParams} from "@share/auth/enums/SessionGetParams";
import {parseJson} from "@common/TypesHelper";
import {decrypt} from "@share/auth/helpers/Aes128Helper";
import {GetParamsSessionData} from "@share/auth/types/GetParamsSessionData";
import {Session} from "@service/types/Session";

@Component({
    name: "GetParamsAuth"
})
export default class GetParamsAuth extends Vue {
    render() {
        return '';
    }

    get sessionData(): string {
        return (this.$route.query[SessionGetParams.SessionData] || '') as string;
    }

    get decryptionKey(): string {
        return (this.$route.query[SessionGetParams.DecryptionKey] || '') as string;
    }

    mounted() {
        if (this.sessionData && this.decryptionKey) {
            const decryptedMessage = decrypt(this.sessionData, this.decryptionKey);

            if (decryptedMessage) {
                const sessionData: GetParamsSessionData = parseJson(decryptedMessage);
                this.$emit('loggedIn', {
                    sessionId: sessionData.sessionId,
                    userId: Number.parseInt(sessionData.userId as string),
                    backend: this.$route.params.backend
                } as Session);
            }
        }

    }
}
